export default "__VITE_ASSET__74fdc2c1__"